const teamDescriptor = {
    key: 'team-expenses',
    title: 'Team Expenses',
    subtitle: 'Payroll and people-related costs',
    description: 'Track payroll, benefits, and people-related spend to understand headcount impact and forecast hiring runway.',
    badge: { direction: 'up', text: '' },
    kpis: [
        { label: 'Total Team Cost', value: '', subtext: '', subColor: '#eb9d00' },
        { label: 'Perfect P&L Variance', value: '', subtext: '', subColor: '#eb9d00' },
        { label: 'Perfect P&L Income', value: '', subtext: '', subColor: '#43a047' },
    ],
    alert: {
        title: 'Team costs are healthy and aligned with growth!',
        body: 'Your team costs increased 2.2% this month due to planned annual merit raises and health insurance premium adjustments. At 28.5% of income, you’re well within the healthy 25–35% range for a solo business with 3 support staff.',
        variant: 'info',
    },
    lineChart: {
        label: 'Team Costs',
        values: [],
        target: null,
    },
    donut: {
        slices: [],
    },
    table: {
        rows: [],
        total: { thisMonth: null, lastMonth: null, changePct: null },
    },
    vendors: [],
};

export default teamDescriptor;
